import { render, staticRenderFns } from "./rehandlecost.vue?vue&type=template&id=cb9eee38"
import script from "./rehandlecost.vue?vue&type=script&lang=js"
export * from "./rehandlecost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports